/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import { t } from 'i18next';

import CompanyCorporateTableFormat from './CompanyCorporateTableFormat';

import { FaHome} from "react-icons/fa";


import Clinomics from "../../images_logo_company/Clinomics_Logo_EN.png"
import ThermoFisher from "../../images_logo_company/Thermo_Fisher_Scientific_logo.png"
import BMS from "../../images_logo_company/BMS_logo.png"
import PacBio from "../../images_logo_company/mdxk.png"
import SNUBH from "../../images_logo_company/SNUBH_logo.png"
import Beckman_Coulter from "../../images_logo_company/Beckman_Coulter_logo.jpg"
import Roche from "../../images_logo_company/Roche.png"
import onedrop from "../../images_logo_company/onedrop_logo.png"
import helixco from "../../images_logo_company/helixco_logo.svg"
import kobic from "../../images_logo_company/kobic_logo.svg"
import kogic from "../../images_logos/kogic_logo.svg"
import unist from "../../images_logos/unist_logo2.svg"
import empty from "../../images_logo_company/empty_logo.png"

import atech from "../../images_logo_company/atech.svg"
import bit from "../../images_logo_company/bit.png"
import daebo from "../../images_logo_company/daebo.jpg"
import deephelix from "../../images_logo_company/deephelix.svg"
import editage from "../../images_logo_company/Editage.svg"
import episday from "../../images_logo_company/episday.png"
import gencore from "../../images_logo_company/gencore.png"
import helixous from "../../images_logo_company/helixous.svg"
import hnggenomics from "../../images_logo_company/hnbgenomics.png"
import icraft from "../../images_logo_company/icraft.png"
import intralinks from "../../images_logo_company/intralinks.png"
import jcbio from "../../images_logo_company/jcbio.svg"
import jnpmedi from "../../images_logo_company/jnpmedi.png"
import koreatoxicology from "../../images_logo_company/koreatoxicology.jpg"
import novogene from "../../images_logo_company/novogene.jpg"
import pgi from "../../images_logo_company/PGI.png"
import philekorea from "../../images_logo_company/philekorea.svg"
import popbio from "../../images_logo_company/popbio.png"
import procagene from "../../images_logo_company/procagen.png"
import sangmyung from "../../images_logo_company/sangmyunguniv.svg"
import supersolution from "../../images_logo_company/supersolution.jpg"
import theragen from "../../images_logo_company/theragen.jpg"
import greenmate from "../../images_logo_company/greenmate.jpg"
import uipa from "../../images_logo_company/uipa.svg"
import unist_found from "../../images_logo_company/unist_foundation.jpg"


import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

const CompanyCorporateTable = () => {
    return(
        <div className="sect-01-box-01-exhibitor-regi">
            <div className="sect-tit">{t("exh_comp_corporate_title")}</div>
            <div className='tbl-exhibitor-comp-corp'>
                <div className='inline-block w-full lg:w-11/12 max-w-[1600px]'>
                <table>
                    <colgroup>
                        <col width="12%"/>
                        <col width="30%"/>
                        <col width="25%"/>
                        <col width="25%"/>
                        <col width="8%"/>
                    </colgroup>
                    <tbody>
                    <tr class="smallCell purple borderUpBoldPurple">
                        <td>
                            {t("exh_comp_corporate_col1")}
                        </td>
                        <td>
                            {t("exh_comp_corporate_col2")}
                        </td>
                        <td>
                            {t("exh_comp_corporate_col3")}
                        </td>
                        <td>
                            {t("exh_comp_corporate_col4")}
                        </td>
                        <td>
                            {t("exh_comp_corporate_col5")}
                        </td>
                    </tr>
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate5_name")} 
                    img = {ThermoFisher} 
                    info = {t("exh_comp_corporate5_info")} 
                    prod = {t("exh_comp_corporate5_product")} 
                    link = 'https://www.thermofisher.com/kr/ko/home'
                    />   
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate8_name")} 
                    img = {PacBio} 
                    info = {t("exh_comp_corporate8_info")} 
                    prod = {t("exh_comp_corporate8_product")} 
                    link = 'http://www.mdxk.co.kr/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate9_name")} 
                    img = {BMS} 
                    info = {t("exh_comp_corporate9_info")} 
                    prod = {t("exh_comp_corporate9_product")} 
                    link = 'https://www.bms.kr/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate10_name")} 
                    img = {jcbio} 
                    info = {t("exh_comp_corporate10_info")} 
                    prod = {t("exh_comp_corporate10_product")} 
                    link = 'http://jcbio.co.kr/'
                    />   
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate13_name")} 
                    img = {SNUBH} 
                    info = {t("exh_comp_corporate13_info")} 
                    prod = {t("exh_comp_corporate13_product")} 
                    link = 'https://www.snubh.org/index.do'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate16_name")} 
                    img = {Beckman_Coulter} 
                    info = {t("exh_comp_corporate16_info")} 
                    prod = {t("exh_comp_corporate16_product")} 
                    link = 'https://www.beckman.kr/?utm_medium=cpc&utm_source=Naver&utm_campagin=Brand&utm_content=homelink&utm_term=%EB%B2%A1%ED%81%AC%EB%A7%8C%EC%BF%A8%ED%84%B0&n_media=27758&n_query=%EB%B2%A1%ED%81%AC%EB%A7%8C%EC%BF%A8%ED%84%B0&n_rank=1&n_ad_group=grp-a001-04-000000018212267&n_ad=nad-a001-04-000000168916430&n_keyword_id=nkw-a001-04-000003282946535&n_keyword=%EB%B2%A1%ED%81%AC%EB%A7%8C%EC%BF%A8%ED%84%B0&n_campaign_type=4&n_contract=tct-a001-04-000000000548951&n_ad_group_type=5&NaPm=ct%3Dl78omr0g%7Cci%3D0yG0003C6urx7BV1E1l3%7Ctr%3Dbrnd%7Chk%3D392b11155185d0b4ace376abbcdb2ea5f04d10e8'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate17_name")} 
                    img = {Roche} 
                    info = {t("exh_comp_corporate17_info")} 
                    prod = {t("exh_comp_corporate17_product")} 
                    link = 'http://www.roche-diagnostics.co.kr/Pages/default.aspx'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate18_name")} 
                    img = {onedrop} 
                    info = {t("exh_comp_corporate18_info")} 
                    prod = {t("exh_comp_corporate18_product")} 
                    link = 'http://www.1drop.co.kr/main/main.php'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate19_name")} 
                    img = {helixous} 
                    info = {t("exh_comp_corporate19_info")} 
                    prod = {t("exh_comp_corporate19_product")} 
                    link = 'https://www.helixrus.com/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate20_name")} 
                    img = {procagene} 
                    info = {t("exh_comp_corporate20_info")} 
                    prod = {t("exh_comp_corporate20_product")} 
                    link = 'http://www.procagen.com/user/main.aspx'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate21_name")} 
                    img = {empty} 
                    info = {t("exh_comp_corporate21_info")} 
                    prod = {t("exh_comp_corporate21_product")} 
                    link = 'http://www.kbiocmocenter.or.kr'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate22_name")} 
                    img = {pgi} 
                    info = {t("exh_comp_corporate22_info")} 
                    prod = {t("exh_comp_corporate22_product")} 
                    link = 'http://www.pgi.re.kr'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate23_name")} 
                    img = {intralinks} 
                    info = {t("exh_comp_corporate23_info")} 
                    prod = {t("exh_comp_corporate23_product")} 
                    link = 'http://www.intralinks.com/kr'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate24_name")} 
                    img = {hnggenomics} 
                    info = {t("exh_comp_corporate24_info")} 
                    prod = {t("exh_comp_corporate24_product")} 
                    link = 'http://www.hnbgenomics.com'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate25_name")} 
                    img = {helixco} 
                    info = {t("exh_comp_corporate25_info")} 
                    prod = {t("exh_comp_corporate25_product")} 
                    link = 'http://www.helixco.co.kr'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate26_name")} 
                    img = {bit} 
                    info = {t("exh_comp_corporate26_info")} 
                    prod = {t("exh_comp_corporate26_product")} 
                    link = 'http://www.b-itsolution.com'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate27_name")} 
                    img = {daebo} 
                    info = {t("exh_comp_corporate27_info")} 
                    prod = {t("exh_comp_corporate27_product")} 
                    link = 'http://www.dbcs.co.kr'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate28_name")} 
                    img = {supersolution} 
                    info = {t("exh_comp_corporate28_info")} 
                    prod = {t("exh_comp_corporate28_product")} 
                    link = 'http://www.supersolution.co.kr'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate29_name")} 
                    img = {icraft} 
                    info = {t("exh_comp_corporate29_info")} 
                    prod = {t("exh_comp_corporate29_product")} 
                    link = 'http://www.icraft21.com'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate30_name")} 
                    img = {editage} 
                    info = {t("exh_comp_corporate30_info")} 
                    prod = {t("exh_comp_corporate30_product")} 
                    link = 'http://www.editage.co.kr'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate31_name")} 
                    img = {kobic} 
                    info = {t("exh_comp_corporate31_info")} 
                    prod = {t("exh_comp_corporate31_product")} 
                    link = 'https://www.kobic.re.kr/kobic/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate32_name")} 
                    img = {philekorea} 
                    info = {t("exh_comp_corporate32_info")} 
                    prod = {t("exh_comp_corporate32_product")} 
                    link = 'https://philekorea.kr/default/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate37_name")} 
                    img = {deephelix} 
                    info = {t("exh_comp_corporate37_info")} 
                    prod = {t("exh_comp_corporate37_product")} 
                    link = 'https://deephelix.net/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate38_name")} 
                    img = {popbio} 
                    info = {t("exh_comp_corporate38_info")} 
                    prod = {t("exh_comp_corporate38_product")} 
                    link = 'https://www.popbio.co.kr/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate39_name")} 
                    img = {gencore} 
                    info = {t("exh_comp_corporate39_info")} 
                    prod = {t("exh_comp_corporate39_product")} 
                    link = 'http://www.genkore.com/'
                    />    
                    {/* <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate40_name")} 
                    img = {empty} 
                    info = {t("exh_comp_corporate40_info")} 
                    prod = {t("exh_comp_corporate40_product")} 
                    link = 'http://www.invitesgenomics.com/main/main.php'
                    />     */}
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate41_name")} 
                    img = {atech} 
                    info = {t("exh_comp_corporate41_info")} 
                    prod = {t("exh_comp_corporate41_product")} 
                    link = 'https://www.atech1221.com/main'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate42_name")} 
                    img = {greenmate} 
                    info = {t("exh_comp_corporate42_info")} 
                    prod = {t("exh_comp_corporate42_product")} 
                    link = 'http://greenmate.co.kr/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate43_name")} 
                    img = {episday} 
                    info = {t("exh_comp_corporate43_info")} 
                    prod = {t("exh_comp_corporate43_product")} 
                    link = 'https://episday.com/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate44_name")} 
                    img = {jnpmedi} 
                    info = {t("exh_comp_corporate44_info")} 
                    prod = {t("exh_comp_corporate44_product")} 
                    link = 'https://www.jnpmedi.com/?lang=ko'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate45_name")} 
                    img = {novogene} 
                    info = {t("exh_comp_corporate45_info")} 
                    prod = {t("exh_comp_corporate45_product")} 
                    link = 'https://en.novogene.com/'
                    />    
                    {/* <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate46_name")} 
                    img = {empty} 
                    info = {t("exh_comp_corporate46_info")} 
                    prod = {t("exh_comp_corporate46_product")} 
                    link = 'https://www.cjbioscience.com/'
                    />     */}
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate47_name")} 
                    img = {empty} 
                    info = {t("exh_comp_corporate47_info")} 
                    prod = {t("exh_comp_corporate47_product")} 
                    link = 'http://www.nanoscope.co.kr/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate48_name")} 
                    img = {empty} 
                    info = {t("exh_comp_corporate48_info")} 
                    prod = {t("exh_comp_corporate48_product")} 
                    link = 'https://www.thyroscope.com/'
                    />   
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate49_name")} 
                    img = {empty} 
                    info = {t("exh_comp_corporate49_info")} 
                    prod = {t("exh_comp_corporate49_product")} 
                    link = ''
                    />   
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate50_name")} 
                    img = {theragen} 
                    info = {t("exh_comp_corporate50_info")} 
                    prod = {t("exh_comp_corporate50_product")} 
                    link = 'http://www.theragenbio.com'
                    />   
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate51_name")} 
                    img = {sangmyung} 
                    info = {t("exh_comp_corporate51_info")} 
                    prod = {t("exh_comp_corporate51_product")} 
                    link = 'http://www.bioinformatics.smu.ac.kr'
                    />   
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate52_name")} 
                    img = {koreatoxicology} 
                    info = {t("exh_comp_corporate52_info")} 
                    prod = {t("exh_comp_corporate52_product")} 
                    link = 'https://www.kitox.re.kr'
                    />   
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate53_name")} 
                    img = {uipa} 
                    info = {t("exh_comp_corporate53_info")} 
                    prod = {t("exh_comp_corporate53_product")} 
                    link = 'https://www.uipa.or.kr'
                    />   
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate54_name")} 
                    img = {empty} 
                    info = {t("exh_comp_corporate54_info")} 
                    prod = {t("exh_comp_corporate54_product")} 
                    link = 'https://www.pireco.org'
                    />   
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate33_name")} 
                    img = {unist} 
                    info = {t("exh_comp_corporate33_info")} 
                    prod = {t("exh_comp_corporate33_product")} 
                    link = 'https://innopolis.unist.ac.kr/'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate34_name")} 
                    img = {unist_found} 
                    info = {t("exh_comp_corporate34_info")} 
                    prod = {t("exh_comp_corporate34_product")} 
                    link = 'https://industry.unist.ac.kr/entrepreneurship-center'
                    />    
                    <CompanyCorporateTableFormat 
                    name={t("exh_comp_corporate15_name")} 
                    img = {Clinomics} 
                    info = {t("exh_comp_corporate15_info")} 
                    prod = {t("exh_comp_corporate15_product")} 
                    link = 'https://clinomics.com/ko/'
                    />  
                    <tr class="largeCell">
                        <td class="bigfont" rowSpan="2">
                            {t("exh_comp_corporate35_name")}
                        </td>
                        <td className="" rowSpan="2">
                            <div className='object-fill w-64 lg:w-80 p-6 lg:p-12 inline-block'>
                            <img className="w-full h-full" src={kogic}></img>
                            </div>
                            {/*{t("exh_comp_sponsor1_name")}*/}
                        </td>
                        <td class="leftAlign" rowSpan="2">
                            {t("exh_comp_corporate35_info")}
                        </td>
                        <td>
                            {t("exh_comp_corporate35_product")}
                        </td>
                        <td rowSpan="2">
                            <a href=''>
                                <div className='exhibitor-comp-corp-icon-wrap'>
                                    <FaHome size="30px"/>
                                </div>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        {t("exh_comp_corporate36_product")}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    )
}

export default CompanyCorporateTable;